import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3028766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "项目情况", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("万元")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "考察说明")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "其他情况", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_11 = { class: "submit-btn" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 提交 ")
const _hoisted_13 = { class: "person" }
const _hoisted_14 = {
  class: "type_List",
  style: {"max-height":"380px","overflow-y":"scroll"}
}
const _hoisted_15 = { class: "bottom-section" }
const _hoisted_16 = { class: "btn-group" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确认")

import { onMounted, reactive, ref } from 'vue'
import { declareSave, saveProject } from '@/apis/declare'
import { getCity, getProjectConfigs } from '@/apis/common'
import { Toast } from 'vant'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import { getStaffInfo } from '@/apis/home'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const typeName = {
  //  自定义 columns 结构中的字段
  id: 'id',
  text: 'name'
}
const cascaderValue = ref('')

// 项目地址 选择数据
const cityPicker = ref(null)

const CityshowPicker = ref(false)
// 项目申报 选择数据
const declareShowPicker = ref(false)
const epcShowPicker = ref(false)
const modeShowPicker = ref(false)

// 所属事业部
const belongAreaShowPicker = ref(false)
// 投标
const tenderShowPicker = ref(false)
const tenderOrganShowPicker = ref(false)

const CapitalshowPicker = ref(false)

// 项目类型 选择数据
const TypeshowPicker = ref(false)
// 项目子型 选择数据
const personTypeshowPicker = ref(false)
const state = reactive({
  project: {} as saveProject,
  // 厨具1，网络2，广告3，餐饮4，超市5，配送6，职校7
  projectTypeName: '', // 项目类别 展示数据
  projectpersonTypeName: '', // 项目子类别 展示数据
  modeName: '', //  展示数据
  EPCName: '', // 工程类别 展示数据
  provinceName: '', // 项目地址 展示数据
  declareName: '', // 申报类型 展示数据
  belongAreaName: '', // 所属事业部
  tenderName: '', // 投标方式 展示数据 name
  tenderOrganName: '', // 投标机构 展示数据 name
  capitalName: '', //资金来源 展示数据
  pid: 0,
  city_list: [], //城市 选择数据
  type_List: [], //项目类别 选择数据
  declare_list: [], // 申报类型 选择数据
  belongAreaList: [], // 所属事业部
  tenderList: [], // 投标方式
  tenderOrganList: [], // 投标机构
  EPC_list: [
    { id: 1, name: '新建' },
    { id: 2, name: '改造' }
  ],
  mode_list: [], // 经营方式
  capital_list: [] // 资金来源 选择数据
})

const checked = ref('1')

const onClickTab = data => {
  console.log('tab', data)
}

const onCityConfirm = ({ selectedOptions }) => {
  state.provinceName = selectedOptions.map(option => option.text).join('')
  console.log(selectedOptions)

  if (selectedOptions.length >= 0) state.project.province_id = selectedOptions[0].value
  if (selectedOptions.length >= 1) state.project.city_id = selectedOptions[1].value
  if (selectedOptions.length >= 2) state.project.area_id = selectedOptions[2].value

  CityshowPicker.value = false
}
const onCityChange = async (data: { value: number }) => {
  state.pid = data.value
  const res = await getCity({ pid: state.pid })
  if (res.code == 200) {
    if (res.data) {
      state.city_list.forEach(i => {
        // console.log('二级联动', data.value)
        for (let l = 0; l < i.children.length; l++) {
          if (data.value === i.children[l].value) {
            let children = []
            for (let e = 0; e < res.data.length; e++) {
              children.push({ text: res.data[e].name, value: res.data[e].id, children: null })
            }
            i.children[l].children = children
          }
        }
        if (data.value == i.value) {
          for (let e = 0; e < res.data.length; e++) {
            i.children.push({ text: res.data[e].name, value: res.data[e].id, children: [] })
          }
        }
      })
    }
  }
}
// 多选
const personValue = ref([])

const checkboxGroupPerson = ref(null)
// 关闭
const closePersonType = () => {
  console.log('关闭')
  // checkboxGroupPerson.value.toggleAll(false)
}
// 确认
const conPersonfirm = () => {
  console.log('====>personValue', personValue.value.toString())
  state.project.person_type = personValue.value.toString()
  let date = state.type_List.filter(item => personValue.value.indexOf(item.id) > -1)
  state.projectpersonTypeName = date.map(item => item.name).toString()
  personTypeshowPicker.value = false
}
// 重置
const personReset = () => {
  checkboxGroupPerson.value.toggleAll(false)
}

const onModeConfirm = (data: { id: string; name: string }) => {
  console.log('data: ', data)
  state.modeName = data.name
  state.project.mode_operation = data.id
  modeShowPicker.value = false
}

const onEPCConfirm = (data: { id: string; name: string }) => {
  state.EPCName = data.name
  state.project.project_type = data.id
  epcShowPicker.value = false
}

const onCapitalConfirm = (data: { id: string; name: string }) => {
  state.capitalName = data.name
  state.project.capital_source = data.id
  CapitalshowPicker.value = false
}

const onDeclareConfirm = (data: { id: string; name: string }) => {
  state.project.declare_type = data.id
  state.declareName = data.name
  declareShowPicker.value = false
}
// 投标方式
const onTenderOrganConfirm = (data: { id: number; name: string }) => {
  tenderOrganShowPicker.value = false
  state.project.tender_organ = data.id
  state.tenderOrganName = data.name
}
// 投标机构
const onTenderConfirm = (data: { id: number; name: string }) => {
  tenderShowPicker.value = false
  state.project.tender = data.id
  state.tenderName = data.name
}
// 所属事业部
const onAreaConfirm = (data: { id: number; name: string }) => {
  belongAreaShowPicker.value = false
  state.project.belong_area = data.id
  state.belongAreaName = data.name
}

//onTypeConfirm 选择项目类型确认
const onTypeConfirm = (data: { id: string; name: string }) => {
  if (personValue.value.length > 0) {
    checkboxGroupPerson.value.toggleAll(false)
    state.projectpersonTypeName = ''
  }

  state.project.type_id = data.id
  state.projectTypeName = data.name
  TypeshowPicker.value = false
}

// 省市区查询功能
const get_region = async () => {
  let data = { pid: state.pid }
  const res = await getCity(data)
  if (res.code == 200) {
    if (res.data) {
      res.data.forEach(e => {
        state.city_list.push({ text: e.name, value: e.id, children: [] })
      })
    }
  }
}

// 选择框查询功能
const get_Configs = async () => {
  let data = {
    name: 'lj_sales_project'
  }
  const res = await getProjectConfigs(data)
  if (res.code == 200) {
    // 所属事业部
    for (let key in res.data.belong_area) {
      state.belongAreaList.push({ id: key, name: res.data.belong_area[key] })
    }
    // 投标方式
    for (let key in res.data.tender) {
      state.tenderList.push({ id: key, name: res.data.tender[key] })
    }
    // 投标机构
    for (let key in res.data.tender_organ) {
      state.tenderOrganList.push({ id: key, name: res.data.tender_organ[key] })
    }
    state.type_List = Object.keys(res.data.type).map(item => ({
      id: item,
      name: res.data.type[item]
    }))
    state.declare_list = Object.keys(res.data.declare_type).map(item => ({
      id: item,
      name: res.data.declare_type[item]
    }))
    state.capital_list = Object.keys(res.data.capital_source).map(item => ({
      id: item,
      name: res.data.capital_source[item]
    }))
    state.mode_list = Object.keys(res.data.mode_operation).map(item => ({
      id: item,
      name: res.data.mode_operation[item]
    }))
  }
}
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

onMounted(() => {
  get_region()
  get_Configs()
  // setTimeout(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  // }, 1000)
})
// 保存
const onSubmit = async () => {
  state.project.id = null
  if (state.project.is_comprehensive == '0') {
    state.project.person_type = null
  } else {
    state.project.person_type = personValue.value.toString()
  }
  const res = await declareSave(state.project)
  if (res.code == 200) {
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.push('/project/auditDeclare')
      }
    })
  } else {
    Toast(res.msg)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_cascader = _resolveComponent("van-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).project.name) = $event)),
                maxlength: 15,
                label: "项目名称",
                "input-align": "right",
                placeholder: "请输入 (最多15字)",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).provinceName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).provinceName) = $event)),
                label: "项目地址",
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择项目地址",
                required: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (CityshowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.address,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).project.address) = $event)),
                label: "详细地址",
                "input-align": "right",
                placeholder: "请输入详细地址",
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_3,
              _createVNode(_component_van_field, {
                modelValue: _unref(state).projectTypeName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).projectTypeName) = $event)),
                label: "项目类别",
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择项目类别",
                required: "",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (TypeshowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                name: "radio",
                label: "是否为综合类项目",
                "label-width": "150px",
                "input-align": "right",
                readonly: "",
                required: ""
              }, {
                input: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    modelValue: _unref(state).project.is_comprehensive,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).project.is_comprehensive) = $event)),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_radio, {
                        name: "1",
                        shape: "square"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_radio, {
                        name: "0",
                        shape: "square"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_van_field, {
                label: "项目类子别",
                modelValue: _unref(state).projectpersonTypeName,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).projectpersonTypeName) = $event)),
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "项目类子别",
                required: "",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (personTypeshowPicker.value = true))
              }, null, 8, ["modelValue"]), [
                [_vShow, _unref(state).project.is_comprehensive && _unref(state).project.is_comprehensive == '1']
              ]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).tenderName,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).tenderName) = $event)),
                label: "招标方式",
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择招标方式",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (tenderShowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).tenderOrganName,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).tenderOrganName) = $event)),
                label: "招标机构",
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择招标机构",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (tenderOrganShowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _hoisted_6,
              _createVNode(_component_van_field, {
                modelValue: _unref(state).declareName,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).declareName) = $event)),
                label: "业务类型",
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择申报类型",
                required: "",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (declareShowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).belongAreaName,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(state).belongAreaName) = $event)),
                label: "归属区域",
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择归属区域",
                required: "",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (belongAreaShowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).capitalName,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(state).capitalName) = $event)),
                label: "资金来源",
                "is-link": "",
                readonly: "",
                "input-align": "right",
                placeholder: "请选择资金来源",
                required: "",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (CapitalshowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.project_size,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(state).project.project_size) = $event)),
                label: "项目规模",
                "input-align": "right",
                type: "number",
                placeholder: "请输入预估项目金额",
                required: ""
              }, {
                button: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    size: "small",
                    type: "default",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.contact_name,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(state).project.contact_name) = $event)),
                label: "联系人姓名",
                "input-align": "right",
                placeholder: "请输入联系人姓名",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.contact_phone,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(state).project.contact_phone) = $event)),
                label: "联系人电话",
                "input-align": "right",
                placeholder: "请输入联系人电话",
                required: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).EPCName,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(state).EPCName) = $event)),
                label: "工程类型",
                "input-align": "right",
                placeholder: "请选择工程类型",
                "is-link": "",
                readonly: "",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (epcShowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).modeName,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(state).modeName) = $event)),
                label: "经营方式",
                "input-align": "right",
                placeholder: "请选择经营方式",
                "is-link": "",
                readonly: "",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (modeShowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, { title: "考察说明" }, {
                    title: _withCtx(() => [
                      _hoisted_8
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        modelValue: _unref(state).project.inspection_instructions,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(state).project.inspection_instructions) = $event)),
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入考察说明",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_9,
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.introduce_staff_name,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(state).project.introduce_staff_name) = $event)),
                label: "介绍人",
                "input-align": "right",
                placeholder: "请输入"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _unref(state).project.collaboration_staff_name,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(state).project.collaboration_staff_name) = $event)),
                label: "协作人",
                "input-align": "right",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_10,
          _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_popup, {
      show: TypeshowPicker.value,
      "onUpdate:show": _cache[30] || (_cache[30] = ($event: any) => ((TypeshowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).type_List,
          onConfirm: onTypeConfirm,
          onCancel: _cache[29] || (_cache[29] = ($event: any) => (TypeshowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: personTypeshowPicker.value,
      "onUpdate:show": _cache[32] || (_cache[32] = ($event: any) => ((personTypeshowPicker).value = $event)),
      closeable: "",
      round: "",
      position: "bottom",
      style: { height: '60%' },
      onClose: closePersonType
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_van_checkbox_group, {
              modelValue: personValue.value,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((personValue).value = $event)),
              ref_key: "checkboxGroupPerson",
              ref: checkboxGroupPerson,
              direction: "horizontal",
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).type_List, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_checkbox, {
                        disabled: _unref(state).project.type_id == item.id ? true : false,
                        name: item.id,
                        shape: "square"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "name"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_van_button, {
                round: "",
                type: "default",
                onClick: personReset,
                class: "btn-group-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                round: "",
                type: "primary",
                onClick: conPersonfirm,
                class: "btn-group-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: CityshowPicker.value,
      "onUpdate:show": _cache[35] || (_cache[35] = ($event: any) => ((CityshowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cascader, {
          modelValue: cascaderValue.value,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((cascaderValue).value = $event)),
          title: "请选择所在地区",
          options: _unref(state).city_list,
          "active-color": "#1989fa",
          onClose: _cache[34] || (_cache[34] = ($event: any) => (CityshowPicker.value = false)),
          onChange: onCityChange,
          onFinish: onCityConfirm,
          swipeable: "",
          onClickTab: onClickTab
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: declareShowPicker.value,
      "onUpdate:show": _cache[37] || (_cache[37] = ($event: any) => ((declareShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).declare_list,
          onConfirm: onDeclareConfirm,
          onCancel: _cache[36] || (_cache[36] = ($event: any) => (declareShowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: CapitalshowPicker.value,
      "onUpdate:show": _cache[39] || (_cache[39] = ($event: any) => ((CapitalshowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).capital_list,
          onConfirm: onCapitalConfirm,
          onCancel: _cache[38] || (_cache[38] = ($event: any) => (CapitalshowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: tenderShowPicker.value,
      "onUpdate:show": _cache[41] || (_cache[41] = ($event: any) => ((tenderShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).tenderList,
          onConfirm: onTenderConfirm,
          onCancel: _cache[40] || (_cache[40] = ($event: any) => (tenderShowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: tenderOrganShowPicker.value,
      "onUpdate:show": _cache[43] || (_cache[43] = ($event: any) => ((tenderOrganShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).tenderOrganList,
          onConfirm: onTenderOrganConfirm,
          onCancel: _cache[42] || (_cache[42] = ($event: any) => (tenderOrganShowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: belongAreaShowPicker.value,
      "onUpdate:show": _cache[45] || (_cache[45] = ($event: any) => ((belongAreaShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).belongAreaList,
          onConfirm: onAreaConfirm,
          onCancel: _cache[44] || (_cache[44] = ($event: any) => (belongAreaShowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: epcShowPicker.value,
      "onUpdate:show": _cache[47] || (_cache[47] = ($event: any) => ((epcShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).EPC_list,
          onConfirm: onEPCConfirm,
          onCancel: _cache[46] || (_cache[46] = ($event: any) => (epcShowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: modeShowPicker.value,
      "onUpdate:show": _cache[49] || (_cache[49] = ($event: any) => ((modeShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          "columns-field-names": typeName,
          columns: _unref(state).mode_list,
          onConfirm: onModeConfirm,
          onCancel: _cache[48] || (_cache[48] = ($event: any) => (modeShowPicker.value = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})